
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insuranceType]/contact-us",
      function () {
        return require("private-next-pages/[insuranceType]/contact-us/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[insuranceType]/contact-us"])
      });
    }
  